<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="true"
    :visible.sync="visible"
    @close="dialogClose()"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="80px"
    >
      <el-form-item label="所属市场" prop="firmName">
        <el-input
          v-model="dataForm.firmName"
          placeholder="所属市场"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item label="设备类型" prop="deviceType">
        <el-select v-model="dataForm.deviceType" placeholder="请选择">
          <el-option
            v-for="value in this.$u.dict.DeviceType"
            :key="value.key"
            :label="value.val"
            :value="value.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="app名称" prop="appName">
        <el-input
          v-model="dataForm.appName"
          placeholder="app名称"
          :disabled="dataForm.id > 0"
        />
      </el-form-item>
      <el-form-item label="版本名" prop="appVersion">
        <el-input v-model="dataForm.appVersion" placeholder="版本名" />
      </el-form-item>
      <el-form-item label="版本号" prop="appVersion">
        <el-input v-model="dataForm.versionCode" placeholder="版本号" />
      </el-form-item>
      <el-form-item label="下载地址" prop="appUrl">
        <el-upload
          ref="upload"
          class="upload-demo"
          drag
          action=""
          :http-request="uploadApk"
          :before-upload="beforeUploadHandle"
          :limit="1"
          :on-exceed="onExceedUpload"
          :multiple="false"
        >
          <i class="el-icon-upload" />
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <el-input
          id="copyText"
          v-model="dataForm.appUrl"
          placeholder="下载地址"
          :readonly="true"
          width="100px"
        >
          <template slot="append">
            <el-link
              id="copyBtn"
              icon="el-icon-document-copy"
              data-clipboard-target="#copyText"
              @click="copyLink(dataForm.appUrl, $event)"
            >
              复制外链
            </el-link>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="dataForm.status" placeholder="请选择">
          <el-option
            v-for="value in this.$u.dict.DisabledStatus"
            :key="value.key"
            :label="value.val"
            :value="value.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="强制更新" prop="forceFlag">
        <el-select v-model="dataForm.forceFlag" placeholder="请选择">
          <el-option
            v-for="value in this.$u.dict.ForceUpdateFlag"
            :key="value.key"
            :label="value.val"
            :value="value.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="更新描述" prop="description">
        <el-input
          type="textarea"
          :row="3"
          v-model="dataForm.description"
          placeholder="更新描述"
          :maxlength="200"
          show-word-limit
        />
      </el-form-item>
      <el-form-item v-if="dataForm.id">
        <p style="color: #F56C6C">注：修改信息后会按照此版本更新app</p>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button
        type="primary"
        @click="dataFormSubmit()"
        :loading="subBtnLoading"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { copyClipboard } from "@/utils";
import vControl from "@/api/version.control";
import dfs from "@/api/dfs";
import _ from "lodash";
import { isPropEqual } from "@/utils";

export default {
  created() {},
  activated() {},
  data() {
    return {
      appNameDisabled: false,
      visible: false,
      uploadNum: 0,
      uploadSuccessNum: 0,
      fileList: [],
      subBtnLoading: false,
      dataForm: {
        id: "",
        deviceType: "",
        appName: "",
        appVersion: "",
        versionCode: "",
        appUrl: "",
        firmId: this.$store.state.versionControl.vuex_firm.id,
        firmName: this.$store.state.versionControl.vuex_firm.name,
        status: this.$u.dict.DisabledStatus.ENABLE.key,
        forceFlag: this.$u.dict.ForceUpdateFlag.NO.key,
        description: "",
        createTime: "",
        modifyTime: ""
      },
      dataRule: {
        deviceType: [
          { required: true, message: "设备类型必选", trigger: "change" }
        ],
        appName: [{ required: true, message: "app名称必填", trigger: "blur" }],
        appVersion: [
          { required: true, message: "版本名必填", trigger: "blur" }
        ],
        versionCode: [
          { required: true, message: "版本号必填", trigger: "blur" }
        ],
        status: [
          { required: true, message: "版本发布状态必选", trigger: "change" }
        ],
        forceFlag: [
          { required: true, message: "版本发布方式必选", trigger: "change" }
        ],
        appUrl: [{ required: true, message: "请先上传", trigger: "blur" }],
        description: [{ max: 200, message: "更新描述最多两百个字" }]
      }
    };
  },
  methods: {
    init(id) {
      this.dataForm.id = id || 0;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          //获取详情
          vControl.getOneById(this.dataForm.id).then(result => {
            this.dataForm = result.data;
            this.$store.commit(
              this.$u.vuexConst.VERSION_CONTROL_STATE_PREFIX +
                this.$u.vuexConst.UPDATE_VERSION_DATA_FORM,
              _.cloneDeep(result.data)
            );
          });
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.subBtnLoading = true;
      let vuex_dataForm = this.$store.state.versionControl.vuex_dataForm;
      if (isPropEqual(this.dataForm, vuex_dataForm)) {
        this.$u.message.success("操作成功，数据未变动");
        this.visible = false;
        this.subBtnLoading = false;
        return;
      }
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          vControl
            .addOrUpdate(this.dataForm)
            .then(() => {
              this.$u.message.success("操作成功");
              this.visible = false;
              this.subBtnLoading = false;
              this.$emit("refreshDataList");
            })
            .catch(() => (this.subBtnLoading = false));
        }
      });
    },
    //对话框关闭
    dialogClose() {
      this.visible = false;
      this.$emit("closeDialog");
    },
    //上传apk
    uploadApk(param) {
      const formData = new FormData();
      formData.append("file", param.file);
      formData.append("accessToken", process.env.VUE_APP_DFS_TOKEN);
      dfs
        .upload(formData)
        .then(result => {
          this.$u.message.success("上传成功");
          this.dataForm.appUrl = result.data;
        })
        .catch(result => {
          this.$u.message.error(result.message);
          this.$refs.upload.clearFiles();
        });
    },
    // 上传之前
    beforeUploadHandle(file) {
      return new Promise((resolve, reject) => {
        this.$confirm(
          `确认上传APK [<span style="color: red">${file.name}</span>]？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        )
          .then(res => {
            this.uploadNum++;
            resolve(res);
          })
          .catch(res => {
            reject(res);
          });
      });
    },
    //超出文件上传数量时
    // eslint-disable-next-line no-unused-vars
    onExceedUpload(files, fileList) {
      this.$u.message.warning(
        "只支持上传一个文件，如需更新，请先移除上一个文件"
      );
    },
    // 复制链接方法
    copyLink(text, event) {
      if (_.isEmpty(text)) {
        this.$u.message.warning("请先上传APK");
        return;
      }
      copyClipboard(dfs.generateDownloadLink(text), event);
    }
  }
};
</script>
